import React from 'react';
import ReactDOM from 'react-dom';
import { toast, ToastContainer } from 'react-toastify';

import ButtonClose from '@/common/components/molecules/ButtonClose/ButtonClose';
import { SNACK_DELAY } from '@/common/constants';

const ToastWrapper = () =>
  ReactDOM.createPortal(
    <ToastContainer
      className="custom-toastify"
      autoClose={SNACK_DELAY}
      closeButton={() => <ButtonClose />}
      position={toast.POSITION.BOTTOM_LEFT}
    />,
    document.querySelector('body'),
  );

export default ToastWrapper;
